
import React from "react";
import { ArrowLeft, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ButtonColorful } from "@/components/ui/button-colorful";

interface ReviewFormFooterProps {
  onBack: () => void;
  onSubmit: () => void;
  isSaving: boolean;
}

export default function ReviewFormFooter({ onBack, onSubmit, isSaving }: ReviewFormFooterProps) {
  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="flex justify-between w-full">
      <Button
        variant="outline"
        onClick={onBack}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to Preferences
      </Button>
      
      <ButtonColorful 
        label={isSaving ? "Saving..." : "Finalize Program"}
        onClick={handleSubmit}
        disabled={isSaving}
        icon="none"
      >
        {!isSaving && <Check className="mr-2 h-4 w-4" />}
      </ButtonColorful>
    </div>
  );
}
